import { getUseAnalyticsHook } from '@frontend/react';
import { useAdvertisingHook } from '@frontend/react/hooks/getUseAdvertisingHook';
import { useSegment } from '@frontend/web-react';
import { addSentryBreadcrumb, getSegment } from '@frontend/web-utils';
import { useRetrieveClientQuery } from '@frontend/web/hooks';
import { Env } from '@frontend/web/utils';
import { useCallback, useEffect, useMemo, useRef } from 'react';

export const useAnalytics = () => {
  const segment = getSegment();
  const { track: segmentTrack, trackRouteChange } = useSegment({ analytics: segment, env: Env.VITE_ENV });
  const { data: client } = useRetrieveClientQuery();

  const { track: originalTrack } = useMemo(() => getUseAnalyticsHook({ client, segmentTrack }), [client, segmentTrack]);
  const { trackAdvertising } = useAdvertisingHook();
  const originalTrackRef = useRef(originalTrack);

  useEffect(() => {
    // eslint-disable-next-line fp/no-mutation
    originalTrackRef.current = originalTrack;
  }, [originalTrack]);

  const track = useCallback<typeof originalTrack>((config) => {
    addSentryBreadcrumb({
      category: 'analytics',
      data: config,
      level: 'info',
      message: `Analytics: ${config.topic}.${config.event.toString()}`,
      type: 'info',
    });

    originalTrackRef.current(config);
  }, []);

  return { track, trackAdvertising, trackRouteChange };
};
